import { all, takeLatest, put } from 'redux-saga/effects';
import { path } from 'ramda';
import { LegalTypes, LegalActions } from './legal.redux';
import * as Contentful from '../../shared/services/contentful';

const getContent = path(['items', '0', 'fields', 'content']);

function* fetchTerms() {
  const data = yield Contentful.fetchLegal('terms-and-conditions');
  const content = getContent(data);
  if (content) {
    yield put(LegalActions.setTermsAndConditions(content));
  }
}

function* fetchPrivacy() {
  const data = yield Contentful.fetchLegal('privacy-policy');
  const content = getContent(data);
  if (content) {
    yield put(LegalActions.setPrivacyPolicy(content));
  }
}

function* fetchCookies() {
  const data = yield Contentful.fetchLegal('cookie-policy');
  const content = getContent(data);
  if (content) {
    yield put(LegalActions.setCookiesPolicy(content));
  }
}

export default function* startupSaga() {
  yield all([takeLatest(LegalTypes.FETCH_TERMS_AND_CONDITIONS, fetchTerms)]);
  yield all([takeLatest(LegalTypes.FETCH_PRIVACY_POLICY, fetchPrivacy)]);
  yield all([takeLatest(LegalTypes.FETCH_COOKIES_POLICY, fetchCookies)]);
}
